import { generatePath } from "react-router";

export const routePaths = {
  dashboard: "/",
  portfolios: "/portfolios",
  portfolioHealth: "/portfolio-health",
  portfolioDetail: "/portfolios/:portfolioId",
  instruments: "/instruments",
  instrumentDetail: "/instruments/:instrumentId",
  corporateActions: "/corporate-actions",
  watchlist: "/watchlist",
  brokers: "/settings/brokers",
  instrumentMapping: "/settings/instrument-mapping",
  admin: "/admin",
  authCallback: "/auth/callback",
} as const;

export type PortfolioTab = "positions" | "transactions" | "dividends" | "realized" | "allocation" | "settings";

export const portfolioTabs: readonly PortfolioTab[] = ["positions", "transactions", "dividends", "realized", "allocation", "settings"];

export type InstrumentMappingTab = "unmapped" | "reconciliation";

export const instrumentMappingTabs: readonly InstrumentMappingTab[] = ["unmapped", "reconciliation"];

export const routeLinks = {
  portfolioDetail(portfolioId: number, tab?: PortfolioTab): string {
    const portfolioPath = generatePath(routePaths.portfolioDetail, { portfolioId: String(portfolioId) });
    const portfolioLink = tab !== undefined && tab !== "positions" ? `${portfolioPath}?tab=${tab}` : portfolioPath;

    return portfolioLink;
  },
  instrumentDetail(instrumentId: number): string {
    const instrumentLink = generatePath(routePaths.instrumentDetail, { instrumentId: String(instrumentId) });

    return instrumentLink;
  },
};
